import { useEffect } from 'react';
import { logProductView } from '../storefront/storefrontEvents';

const VISIBLE_RATIO = 0.5;
const DWELL_MS = 1000;

/**
 * Log a product view once per session when the card stays visible on a listing page.
 */
export function useProductViewImpression({
  enabled,
  categorySlug,
  productId,
  productName,
  viewSource = '',
  authToken,
  rootRef,
}) {
  useEffect(() => {
    if (!enabled || !categorySlug || !productId || !rootRef?.current) return undefined;
    if (typeof IntersectionObserver === 'undefined') return undefined;

    const node = rootRef.current;
    let dwellTimer = null;

    const clearDwell = () => {
      if (dwellTimer != null) {
        window.clearTimeout(dwellTimer);
        dwellTimer = null;
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting && entry.intersectionRatio >= VISIBLE_RATIO) {
          if (dwellTimer != null) return;
          dwellTimer = window.setTimeout(() => {
            dwellTimer = null;
            logProductView({
              categorySlug,
              productId,
              productName,
              viewSource,
              authToken,
            });
          }, DWELL_MS);
          return;
        }
        clearDwell();
      },
      { threshold: [0, VISIBLE_RATIO] }
    );

    observer.observe(node);
    return () => {
      observer.disconnect();
      clearDwell();
    };
  }, [enabled, categorySlug, productId, productName, viewSource, authToken, rootRef]);
}
